<template>
  <div class="card main-info">
    <div class="card-body">
      <h5 class="card-title">Финансы</h5>
      <LineChart class="mt-2" :finances="finances" />
      <div class="finance-summary mt-3">
        <div class="finance-summary__year">Показатели за {{ latestYear }}</div>
        <ul class="info-list mt-2">
          <li
            v-for="factor in factors"
            :key="factor.title"
            class="d-flex flex-row justify-content-between align-items-center border-bottom mt-2"
          >
            <span class="info-value" :class="factor.className">{{ factor.title }}</span>
            <span class="info-bold">{{ factor.text }}</span>
          </li>
        </ul>
        <button class="btn-primary btn-small d-block ms-auto mt-2" @click="emitChangeTab('tab-finances')">
          Подробнее
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import LineChart from './Diagrams/LineChart.vue';
  import { computed, defineComponent } from 'vue';

  export default defineComponent({
    name: 'FinancesInfo',
    components: { LineChart },
    props: {
      finances: {
        type: Object,
        default: () => ({}),
      },
    },
    setup(props, { emit }) {
      const emitChangeTab = (newTab) => {
        emit('change-tab', newTab);
      };
      const yearlyData = computed(() => props.finances?.additional_finances || {});
      const availableYears = computed(() => Object.keys(yearlyData.value).sort());
      const latestYear = computed(() => availableYears.value[availableYears.value.length - 1] || '—');
      const getMetric = (code) => {
        const year = latestYear.value;
        if (!year || year === '—') return null;
        return yearlyData.value?.[year]?.[code]?.СумОтч ?? null;
      };
      const formatCompactCurrency = (value) => {
        if (value === null || value === undefined) return '—';
        const absValue = Math.abs(value);
        if (absValue >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)} млрд руб.`;
        if (absValue >= 1_000_000) return `${(value / 1_000_000).toFixed(1)} млн руб.`;
        if (absValue >= 1_000) return `${(value / 1_000).toFixed(1)} тыс. руб.`;
        return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(value) + ' руб.';
      };
      const factors = computed(() => [
        {
          title: 'Выручка',
          text: formatCompactCurrency(getMetric('2110')),
          className: 'success',
        },
        {
          title: 'Чистая прибыль',
          text: formatCompactCurrency(getMetric('2400')),
          className: getMetric('2400') >= 0 ? 'success' : 'decline',
        },
        {
          title: 'Капитал и резервы',
          text: formatCompactCurrency(getMetric('1300')),
          className: getMetric('1300') >= 0 ? 'success' : 'decline',
        },
      ]);

      return {
        emitChangeTab,
        factors,
        latestYear,
      };
    },
  });
</script>

<style scoped lang="scss">
  .finance-summary__year {
    color: #6d7785;
    font-size: 14px;
  }
</style>
